import { render, staticRenderFns } from "./irisarSoftware.vue?vue&type=template&id=5c1c2428&scoped=true&"
import script from "./irisarSoftware.vue?vue&type=script&lang=js&"
export * from "./irisarSoftware.vue?vue&type=script&lang=js&"
import style0 from "./irisarSoftware.vue?vue&type=style&index=0&id=5c1c2428&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1c2428",
  null
  
)

export default component.exports